let SIGN_REGEXP = /([yMdhsm])(\1*)/g
let DEFAULT_PATTERN = 'yyyy-MM-dd'

function padding (s, len) {
  len = len - (s + '').length
  for (let i = 0; i < len; i++) {
    s = '0' + s
  }
  return s
}

export default {
  /**
   * 判断Object,Array,是否为空.
   *
   * 1.Object支持判断是否为空对象.
   *
   * 2.Array 支持判断是否为空数组.
   *
   * 3.变量 判断结果为 变量如果为 null,undefined,"" 均返回true
   *
   * @param {}
   *            data 需要判断的变量
   * @return Boolean 类型
   */
  isArrOrNull: function (data) {
    if (data == null) // 判断是否为null
      return true
    if (typeof (data) == 'undefined') { // 判断是否为undefined
      return true
    } else if (typeof (data) == 'object') { // 判断是否为对象
      let dataArr = Object.keys(data) //转换为数组
      if (dataArr instanceof Array) { // 判断是否是数组
        if (dataArr.length <= 0) { // 判断数组是否为空
          return true
        }
      }
      return false
    } else if (typeof (data) == 'string') {
      if (data == '') { // 判断是否为空字符串
        return true
      }
      if (data == 'undefined') { // 判断是否为空字符串
        return true
      }
      return false
    }
    return false
  },
  /**
   * @method
   * 对对象批量赋值 注意点:<br>
   * 1.只对对象属性赋值, 对于 属性是 Object,Array 等不做递归赋值<br>
   * 2.只赋值 对象存在的属性赋值,也就是对原对象不做修改 比如 原对象 没有address 属性  那么就不会赋值<br>
   * 3.支持vue 响应式数据赋值,也就是对于data 定义的属性支持响应式<br>
   * @param {Object} sourceData 原对象 ,也就是需要赋值的对象
   * @param {Object} data 数据对象,也就是要值的来源对象
   * @return {boolean} 返回赋值成功还是失败
   */
  ofData (sourceData, data) {
    if (this.isArrOrNull(sourceData) || this.isArrOrNull(data)) {
      return false
    }
    let isData = false
    for (let i in sourceData) {
      if (!this.isArrOrNull(data[i])) {
        sourceData[i] = data[i]
        isData = true
      }
    }
    return isData
  },
  /**
   * 深拷贝 主要用于防止对象间的引用问题
   * @method
   * @param {Array|Object}source 对象/数组
   * @return {Array|Object} 返回拷贝后的新对象/数组
   */
  clone (source) {
    const targetObj = source.constructor === Array ? [] : {} // 判断复制的目标是数组还是对象
    for (let keys in source) { // 遍历目标
      if (source.hasOwnProperty(keys)) {
        if (source[keys] && typeof source[keys] === 'object') { // 如果值是对象，就递归一下
          targetObj[keys] = source[keys].constructor === Array ? [] : {}
          targetObj[keys] = this.clone(source[keys])
        } else { // 如果不是，就直接赋值
          targetObj[keys] = source[keys]
        }
      }
    }
    return targetObj
  },
  /**
   * 图片路径转换
   * @param name 图片地址一般拼接 图片访问url地址
   * @param url 图片数据格式,支持多张 如: xxx,xxx;xxx,xxx;
   * @return {string}
   */
  imgUrl (name, url) {
    if (!url) {
      return ''
    }
    let urlsArr = url.split(';')
    let urlArr = urlsArr[0].split(',')
    let urlStr
    if (urlArr != null && urlArr.length >= 2) {
      urlStr = name + urlArr[0] + '/' + urlArr[1]
    } else {
      urlStr = name + urlArr[0]
    }
    return urlStr
  },
  bankCardShadow (str) {
    let bankCard = '**** **** **** ' + str.toString().substring(str.length - 4, str.length)
    return bankCard
  },
  getQueryStringByName: function (name) {
    let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', ' if ($.isEmptyObject(data)) { // 判断对象是否为空对象\n' +
      '        return true;\n' +
      '      }i')
    let r = window.location.search.substr(1).match(reg)
    let context = ''
    if (r != null)
      context = r[2]
    reg = null
    r = null
    return context == null || context == '' || context == 'undefined' ? '' : context
  },
  formatDate: {
    format: function (date, pattern) {
      pattern = pattern || DEFAULT_PATTERN
      return pattern.replace(SIGN_REGEXP, function ($0) {
        switch ($0.charAt(0)) {
          case 'y':
            return padding(date.getFullYear(), $0.length)
          case 'M':
            return padding(date.getMonth() + 1, $0.length)
          case 'd':
            return padding(date.getDate(), $0.length)
          case 'w':
            return date.getDay() + 1
          case 'h':
            return padding(date.getHours(), $0.length)
          case 'm':
            return padding(date.getMinutes(), $0.length)
          case 's':
            return padding(date.getSeconds(), $0.length)
        }
      })
    },
    parse: function (dateString, pattern) {
      let matchs1 = pattern.match(SIGN_REGEXP)
      let matchs2 = dateString.match(/(\d)+/g)
      if (matchs1.length == matchs2.length) {
        let _date = new Date(1970, 0, 1)
        for (let i = 0; i < matchs1.length; i++) {
          let _int = parseInt(matchs2[i])
          let sign = matchs1[i]
          switch (sign.charAt(0)) {
            case 'y':
              _date.setFullYear(_int)
              break
            case 'M':
              _date.setMonth(_int - 1)
              break
            case 'd':
              _date.setDate(_int)
              break
            case 'h':
              _date.setHours(_int)
              break
            case 'm':
              _date.setMinutes(_int)
              break
            case 's':
              _date.setSeconds(_int)
              break
          }
        }
        return _date
      }
      return null
    }
  },
}



// WEBPACK FOOTER //
// ./src/Common/util.js